import template from './prems-discount-category-selector.html.twig';

const { Component, Context } = Shopware;
const { EntityCollection, Criteria } = Shopware.Data;

Component.register('prems-discount-category-selector', {
    template,
    inheritAttrs: false,

    inject: ['repositoryFactory'],

    props: {
        discountCategory: {
            type: Object,
            required: false,
            default: null
        },
    },
    computed: {
        categoryRepository() {
            return this.repositoryFactory.create('category');
        },
        categoryIds: {
            get() {
                this.ensureValueExist();
                return Object.keys(this.discountCategory.discountCategoryIds).length > 0 ?  this.discountCategory.discountCategoryIds : null;
            },
            set(categoryIds) {
                this.ensureValueExist();
                this.discountCategory.discountCategoryIds = categoryIds;
            }
        },
    },

    created() {
        this.createdComponent();
    },

    data() {
        return {
            categories: null
        };
    },

    methods: {
        createdComponent() {
            this.categories = new EntityCollection(
                this.categoryRepository.route,
                this.categoryRepository.entityName,
                Context.api
            );

            if (!this.categoryIds) {
                return Promise.resolve();
            }

            const criteria = new Criteria();
            criteria.setIds(this.categoryIds);

            return this.categoryRepository.search(criteria, Context.api).then((categories) => {
                this.categories = categories;
            });
        },
        ensureValueExist() {
            if (typeof this.discountCategory.discountCategoryIds === 'undefined' || this.discountCategory.discountCategoryIds === null) {
                this.discountCategory.discountCategoryIds = {};
            }
        },
        setCategoryIds(categories) {
            this.categoryIds = categories.getIds();
            this.categories = categories;
        }
    }
});
